import React, { useMemo } from "react";
import RRProveedor from "../renderRows/RRProveedor";

import './ProveedoresList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

const ProveedoresList = ({proveedoresList, filter, handleEditProveedor}) =>{

    const navigate = useNavigate();

    let proveedoresFiltered = useMemo(()=> proveedoresList.filter(p => {
        return filter != '' ? 
            checkDoubleQuotes(filter) ?
                (normalizeText(p.nroCta) == removeDoubleQuotesFromFilter(filter) || normalizeText(p.nombre) == removeDoubleQuotesFromFilter(filter))
            :
                (normalizeText(p.nroCta).includes(normalizeText(filter)) || normalizeText(p.nombre).includes(normalizeText(filter)))
        : true
    }), [proveedoresList, filter]);

    return <div className="legajosListDiv">
        <button onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        {proveedoresFiltered.map((p,i) => <RRProveedor key={`${i}-${p.nroCta}`} p={p} index={i} handleEditProveedor={handleEditProveedor}/>)}
    </div>

}

export default ProveedoresList;